@if (customErrorMessage()) {
  <p>{{ customErrorMessage() }}</p>
}
@if (!IsTypeSelected() && settings()) {
  <div class="notifications-setting-card">
    <div class="notifications-setting-card-item" (click)="SelectFlange()">
      <div class="header">
        <span class="title"
          ><i nz-icon nzType="icons:flange"></i>
          {{ i18n.langString("flange") }}</span
        >
        <i nz-icon nzType="icons:arrow-right"></i>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("alerts") }}:</span>
        <span [class.active]="settings().notificationsFlangeAlarmEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsFlangeAlarmPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("warnings") }}:</span>
        <span [class.active]="settings().notificationsFlangeWarningEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsFlangeWarningPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("inactive") }}:</span>
        <span [class.active]="settings().notificationsFlangeInactiveEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsFlangeInactivePush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
    </div>

    <div class="notifications-setting-card-item" (click)="SelectPipe()">
      <div class="header">
        <span class="title"
          ><i nz-icon nzType="icons:pipe"></i> {{ i18n.langString("pipe") }}</span
        >
        <i nz-icon nzType="icons:arrow-right"></i>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("alerts") }}:</span>
        <span [class.active]="settings().notificationsPipeAlarmEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsPipeAlarmPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("warnings") }}:</span>
        <span [class.active]="settings().notificationsPipeWarningEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsPipeWarningPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("inactive") }}:</span>
        <span [class.active]="settings().notificationsPipeInactiveEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsPipeInactivePush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
    </div>

    <div class="notifications-setting-card-item" (click)="SelectSteamtrap()">
      <div class="header">
        <span class="title"
          ><i nz-icon nzType="icons:steamtrap"></i>
          {{ i18n.langString("steamtrap_non_abbrev") }}</span
        >
        <i nz-icon nzType="icons:arrow-right"></i>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("steam_trap_blocked") }}:</span>
        <span [class.active]="settings().notificationsSteamtrapAlarmEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsSteamtrapAlarmPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("steam_trap_blow_through") }}:</span>
        <span [class.active]="settings().notificationsSteamtrapWarningEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsSteamtrapWarningPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("inactive") }}:</span>
        <span [class.active]="settings().notificationsSteamtrapInactiveEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsSteamtrapInactivePush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
    </div>

    <div class="notifications-setting-card-item" (click)="SelectRotatingEq()">
      <div class="header">
        <span class="title"
          ><i nz-icon nzType="icons:rotatingEqu"></i>
          {{ i18n.langString("rotatingequipment") }}</span
        >
        <i nz-icon nzType="icons:arrow-right"></i>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("critical") }}:</span>
        <span [class.active]="settings().notificationsNanoCriticalEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsNanoCriticalPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("warning") }}:</span>
        <span [class.active]="settings().notificationsNanoWarningEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsNanoWarningPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("working_fine") }}:</span>
        <span [class.active]="settings().notificationsNanoWorkingEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsNanoWorkingPush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
      <div class="row">
        <span class="label">{{ i18n.langString("inactive") }}:</span>
        <span [class.active]="settings().notificationsNanoInactiveEmail">{{
          i18n.langString("email")
        }}</span>
        <span [class.active]="settings().notificationsNanoInactivePush">{{
          i18n.langString("push_notification_abbrev")
        }}</span>
      </div>
    </div>
  </div>
}
@if (IsTypeSelected()) {
  <h1>{{ getTitle() }}</h1>

  @if (success() && !error() && !permission_error()) {
    <div class="toast success">
      <i
        nz-icon
        class="inline-error-icon multicolorIcon"
        nzType="icons:check-circle-filled"
      ></i>
      <span>{{ i18n.langString("changes_successful") }}</span>
    </div>
  }
  @if (error()) {
    <div class="toast error">
      <i
        nz-icon
        class="inline-error-icon fillwhite"
        nzType="icons:error-exclamation-circle"
      ></i>
      <span>{{ i18n.langString("changes_problem") }}</span>
    </div>
  }
  @if (permission_error()) {
    <div class="toast error">
      <i
        nz-icon
        class="inline-error-icon fillwhite"
        nzType="icons:error-exclamation-circle"
      ></i>
      <span>{{ i18n.langString("push_permission_denied") }}</span>
    </div>
  }

  <div class="notification-type-envelope">
    <div class="notification-type-title">
      <i
        nz-icon
        class="inline-error-icon"
        nzType="icons:status-exclamation-triangle"
      ></i>
      <span>
        @if (IsSteamtrap()) {
          {{ i18n.langString("steam_trap_blocked") }}
        } @else if (IsRotatingEq()) {
          {{ i18n.langString("critical") }}
        } @else {
          {{ i18n.langString("alerts") }}
        }
      </span>
    </div>

    <app-email-toggle
      [settings]="settings()"
      [loading]="loading()"
      [userEmail]="UserEmail()"
      [value]="alarmEmailEnabled()"
      (valueChange)="updateEmailSetting('Alarm', $event)"
    ></app-email-toggle>

    <app-push-notification-toggle
      [settings]="settings()"
      [loading]="loading()"
      [value]="alarmPushEnabled()"
      (valueChange)="updatePushSetting('Alarm', $event)"
      [reset]="reset()"
    ></app-push-notification-toggle>
  </div>

  <div class="notification-type-envelope">
    <div class="notification-type-title">
      <i
        nz-icon
        class="inline-error-icon"
        nzType="icons:status-exclamation-octagon"
      ></i>
      <span>
        @if (IsSteamtrap()) {
          {{ i18n.langString("steam_trap_blow_through") }}
        } @else {
          {{ i18n.langString("warnings") }}
        }
      </span>
    </div>

    <app-email-toggle
      [settings]="settings()"
      [loading]="loading()"
      [userEmail]="UserEmail()"
      [value]="warningEmailEnabled()"
      (valueChange)="updateEmailSetting('Warning', $event)"
    ></app-email-toggle>

    <app-push-notification-toggle
      [settings]="settings()"
      [loading]="loading()"
      [value]="warningPushEnabled()"
      (valueChange)="updatePushSetting('Warning', $event)"
      [reset]="reset()"
    ></app-push-notification-toggle>
  </div>

  <div class="notification-type-envelope">
    <div class="notification-type-title">
      <i nz-icon class="inline-error-icon" nzType="icons:inactive"></i>
      <span>{{ i18n.langString("inactive") }}</span>
    </div>

    <app-email-toggle
      [settings]="settings()"
      [loading]="loading()"
      [userEmail]="UserEmail()"
      [value]="inactiveEmailEnabled()"
      (valueChange)="updateEmailSetting('Inactive', $event)"
    ></app-email-toggle>

    <app-push-notification-toggle
      [settings]="settings()"
      [loading]="loading()"
      [value]="inactivePushEnabled()"
      (valueChange)="updatePushSetting('Inactive', $event)"
      [reset]="reset()"
    ></app-push-notification-toggle>
  </div>

  @if (IsRotatingEq()) {
    <div class="notification-type-envelope">
      <div class="notification-type-title">
        <i nz-icon class="inline-error-icon" nzType="icons:status-check"></i>
        <span>{{ i18n.langString("working_fine") }}</span>
      </div>

      <app-email-toggle
        [settings]="settings()"
        [loading]="loading()"
        [userEmail]="UserEmail()"
        [value]="workingEmailEnabled()"
        (valueChange)="updateEmailSetting('Working', $event)"
      ></app-email-toggle>

      <app-push-notification-toggle
        [settings]="settings()"
        [loading]="loading()"
        [value]="workingPushEnabled()"
        (valueChange)="updatePushSetting('Working', $event)"
        [reset]="reset()"
      ></app-push-notification-toggle>
    </div>
  }
  @if (loading()) {
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  }
}

<nz-modal
  [nzVisible]="pushNotificationModalVisible()"
  (nzOnCancel)="closePushNotificationModal(false)"
  (nzOnClose)="closePushNotificationModal(false)"
  [nzFooter]="null"
  [nzCloseIcon]="'icons:exit'"
  [nzTitle]="i18n.langString('push_notification')"
>
  <div *nzModalContent>
    <p>{{ i18n.langString("push_notification_modal_text") }}</p>

    @if (!requestingNotificationPermission()) {
      <app-asset-nav-button
        (clickEvent)="requestNotificationPermission()"
        blackBG="true"
        [bypassConnectedStatus]="true"
        >{{ i18n.langString("always") }}</app-asset-nav-button
      >

      <app-asset-nav-button
        id="never-button"
        [bypassConnectedStatus]="true"
        (clickEvent)="closePushNotificationModal(false)"
        >{{ i18n.langString("never") }}</app-asset-nav-button
      >
    } @else {
      <app-spinner
        [black]="true"
        class="grant-permission-spinner"
      ></app-spinner>
    }
  </div>
</nz-modal>

<nz-modal
  [nzVisible]="!!customAlertMessage()"
  (nzOnCancel)="closeCustomAlert()"
  (nzOnClose)="closeCustomAlert()"
  [nzFooter]="null"
  [nzCloseIcon]="'icons:exit'"
  [nzTitle]="customAlertTitle() ?? undefined"
>
  <div *nzModalContent>
    <p>{{ customAlertMessage() }}</p>

    @if (instructionsAddToHomeScreenIOS()) {
      <app-asset-nav-button
        (clickEvent)="DisplayAddToHomeScreenIOSInstructions()"
        blackBG="true"
        [bypassConnectedStatus]="true"
        >{{ i18n.langString("instructions") }}</app-asset-nav-button
      >
    }

    <app-asset-nav-button
      (clickEvent)="closeCustomAlert()"
      blackBG="true"
      [bypassConnectedStatus]="true"
      >{{ i18n.langString("okay") }}</app-asset-nav-button
    >
  </div>
</nz-modal>
